import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo.png";
import L from "../../../constants/baysportLabels";
import { usePortal } from "../../../context/PortalContext";
import {
  applyAuthPageTheme,
  resolveAuthPageBranding,
} from "../../../utils/authPageBranding";
import PortalSwitcher from "../PortalSwitcher";
import AuthSteps from "./AuthSteps";
import a from "./auth.module.css";

export default function AuthShell({
  backTo = "/",
  backLabel = "Назад",
  showSwitcher = true,
  showTrust = false,
  showBrand = true,
  wide = false,
  cardTitle,
  hint,
  clubTag,
  stepCurrent,
  stepTotal,
  stepLabels,
  segment,
  modern = false,
  children,
  footer,
}) {
  const { clinic } = usePortal();
  const authBrand = useMemo(() => resolveAuthPageBranding(clinic), [clinic]);

  useEffect(() => {
    applyAuthPageTheme(clinic);
  }, [clinic]);

  const hasSteps =
    stepCurrent != null &&
    stepTotal != null &&
    stepTotal > 1 &&
    Array.isArray(stepLabels) &&
    stepLabels.length > 0;

  const hasHead = Boolean(cardTitle || hint || hasSteps);
  const resolvedClubTag = authBrand.personalized
    ? null
    : clubTag !== undefined
      ? clubTag
      : authBrand.clubTag;
  const brandLogo = authBrand.logoSrc || (authBrand.personalized ? null : logo);
  const brandTitle = authBrand.showProductName
    ? L.productName
    : authBrand.brandTitle;
  const showClubTag = Boolean(resolvedClubTag);

  const brandBlock =
    showBrand && (brandLogo || brandTitle) ? (
    <div className={modern ? a.modernBrand : a.pageBrand}>
      {brandLogo ? (
        <img
          src={brandLogo}
          alt=""
          className={
            authBrand.personalized
              ? `${a.pageBrandLogo} ${a.pageBrandLogoClub}`
              : a.pageBrandLogo
          }
          width={modern ? 48 : 32}
          height={modern ? 48 : 32}
        />
      ) : null}
      {brandTitle ? (
        <span className={modern ? a.modernBrandName : a.pageBrandName}>
          {brandTitle}
        </span>
      ) : null}
    </div>
  ) : null;

  return (
    <div
      className={[
        a.page,
        modern ? a.pageModern : "",
        authBrand.personalized ? a.pageClubBranded : "",
        authBrand.themeMode === "dark" ? a.pageAuthDark : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className={a.center}>
        {!modern ? (
          <header className={a.topBar}>
            <Link to={backTo} className={a.backLink}>
              ← {backLabel}
            </Link>
            {showSwitcher ? (
              <PortalSwitcher />
            ) : (
              <span className={a.topBarSpacer} aria-hidden />
            )}
          </header>
        ) : null}

        {modern ? (
          <header className={a.modernTopBar}>
            <Link to={backTo} className={a.modernBack}>
              ← {backLabel}
            </Link>
          </header>
        ) : null}

        {brandBlock}

        {segment}

        <div className={`${a.card} ${wide ? a.cardWide : ""} ${modern ? a.cardModern : ""}`}>
          {modern && (showClubTag || cardTitle || hint || hasSteps) ? (
            <div className={a.modernHead}>
              {showClubTag ? (
                <span className={a.clubTag}>{resolvedClubTag}</span>
              ) : null}
              {cardTitle ? <h1 className={a.modernTitle}>{cardTitle}</h1> : null}
              {hasSteps ? (
                <AuthSteps
                  current={stepCurrent}
                  total={stepTotal}
                  labels={stepLabels}
                />
              ) : null}
              {hint ? <p className={a.modernSubtitle}>{hint}</p> : null}
            </div>
          ) : null}

          {hasHead && !modern ? (
            <div className={a.cardHead}>
              {cardTitle ? <h1 className={a.title}>{cardTitle}</h1> : null}
              {hasSteps ? (
                <AuthSteps
                  current={stepCurrent}
                  total={stepTotal}
                  labels={stepLabels}
                />
              ) : null}
              {hint ? <p className={a.subtitle}>{hint}</p> : null}
            </div>
          ) : null}

          <div className={a.body}>{children}</div>

          {footer ? <div className={a.foot}>{footer}</div> : null}
        </div>

        {showTrust ? (
          <p className={a.trustLine}>Журнал · Абонементы · Группы</p>
        ) : null}
      </div>
    </div>
  );
}
